<template>
  <div class="cmp-licences-licences-licence_list dt-page">
    <div class="dt-page--top-bar v1">
      <div  class="dt-page--add-button">
          <div class="dt-icon-container">
            <img
              @click="onAddLicenceClicked"
              class="dt-icon v5 s1"
              src="static/buttons/add.svg"
              alt
            />
          </div>
        </div>
     
      <div class="search"  style="max-width: 430px">
        
        <InputField
          :value="basicFilter.searchString"
          :placeholder="'Search'"
          :config="{
            borderStyle: 'bottom',
            maxWidth:'200px',
            minWidth:'200px',
            width:'200px'
          }"
          @keyup="onSearchInputKeyup"
        />
        <DTCheckbox
          :id="'active'"
          :label="$t('active')"
          :checked="basicFilter.active"
          @click="onCheckBoxClicked"
          :h="'auto'"
        />
        <DTIconButton
          :classNames="'search--advanced'"
          :text="'Advanced Search'"
          :style="{
            minWidth: '148px',
            maxWidth: '148px',
            cursor:'pointer'
          }"
          icon="add-blue"
          @click="onAdvancedSearchClick"
        />

        
      </div>
      <div class="search-config--container">
        <div class="search-config">
          <SearchConBadge
            v-for="sconKey of filteredAdvancedSearchConfigKeys"
            :key="sconKey"
            v-bind="searchConfigKey(sconKey)"
            @delete="onSearchConDelete"
          />
        </div>
      </div>
       <div class="right-container ut-colcen">
        <!-- <v-menu offset-y class="bl-more-menu">
          <button class="dt-button s0 filter-bar-button" slot="activator">
            <v-icon>more_horiz</v-icon>
          </button>
          <v-list class="filter-more-options-list">
            <v-list-tile
              class="options-item"
              v-for="(item, index) in dropdownItems"
              :key="index"
              @click="(e) => onMenuItemClicked(item)"
            >
              <v-list-tile-title>{{ item.title }}</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu> -->
        <v-menu offset-y :left="true" class="bl-more-menu">
              <button
                class="dt-button v5 s22p"
              
                slot="activator"
              >
                <img
                  src="static/icons/options/options-blue.svg"
                  alt="options"
                  class="dt-icon s18p"
                />
              </button>
              <v-list class="filter-more-options-list">
                <v-list-tile
                  class="options-item"
                  v-for="(item, index) in dropdownItems"
                  :key="index"
                  @click="(e) => onMenuItemClicked(item)"
                >
                  <v-list-tile-title
                    :class="{
                      'ut-text-error': item.error
                        ? true
                        : false,
                    }"
                    >{{ item.title }}</v-list-tile-title
                  >
                </v-list-tile>
              </v-list>
            </v-menu>
        <!-- <div class="ut-flex">
          <button
            class="dt-button v5 s8"
             @click.stop="onLicenceLineClick"
          >
            {{ $t("Export Licence Lines") }}
          </button>
          <button
            class="dt-button v5 s8"
            @click.stop="onExportClick"
          >
            {{ $t("Export") }}
          </button>
          
          <button
            class="dt-button v5 s8"
             @click.stop="onBatchClick"
          >
            {{ $t("Batch") }}
          </button>
        </div> -->
      </div>
    </div>
    <div class="dt-page--body" :style="{ '--offset': '120px' }">
      <NTable
        class="h1"
        :headers="headers"
        :config="tableConfig"
        :items="list"
        :loadingFlag="loadingFlag"
        @scrollnext="onListScroll"
        :id="'licences-licences-licence_list'"
      >
        <template v-slot:item="{ item, tdcon }">
          <tr
            @click="onLicenceClicked(item)"
            :class="{
              selected: selectedRow(item),
            }"
          >
            <td style="white-space:nowrap;" v-bind="tdcon('licence')">
              <div class="ut-flex">
                <DtStatus
                  :statusTVList="statusTV"
                  :item="{ itemID:item.licence_id ,colorPropertyName:'licence_status_id',colorPropertyValue:item.licence_status_id,colorName:'status_colour',colorValue:item.status_colour,}"
                  @updateStatus="onStatusChange"
                />
                <div style="font-weight: bold;margin-left:3px">
                  <b>{{ item["licence"] }}</b>
                </div>
              </div>
              <!-- <div class="ut-flex">
                  <div
                    class="circle-status"
                    style="border:1px solid black;"
                    :style="{
                      backgroundColor: `#${item['status_colour']}`,
                      
                    }"
                  ></div>
                  <span class="txtov" style="font-weight: bold; margin-left: 3px">{{item["licence"]}}</span>
              </div> -->
              <!-- <span style="font-weight: bold;" class="txtov" :title="item.licence_name"
                >{{ item["licence_name"] }}
              </span> -->
            </td>
            <td v-bind="tdcon('account')">
              <div style="flex-direction: column;display: flex;">
                <span v-if="item['licence_account']" style="flex:1" class="txtov">{{item["licence_account"]}}</span>
                <span v-if="item['territory_name']" style="flex:1" class="txtov">{{item["territory_name"]||''}}</span>
              </div>  
            </td>
            
            <td v-bind="tdcon('active')">
              <span class="txtov">{{item["active_flag"]||0}}</span>
                <!-- <div class="ut-rowcen">
                  <div class="dt-checkbox v2 s1 ">
                    <input
                      class="disabled"
                      type="checkbox"
                      :name="'active_flag'"
                      :id="'active_flag'"
                      :checked="item['active_flag']"
                    
                      @click="(e) => onCheckBoxChange(e, item)"
                    />
                    <div class="checkmark"></div>
                  </div>
                </div> -->
            </td>
            <td v-bind="tdcon('period')">
              <div class="ut-flex" style="flex-direction:column;">
                <span style="min-height: 20px;">{{ item["start_date"]||'' }}</span>
                <span style="min-height: 20px;">{{ item["end_date"]||'' }}</span>
              </div>
            </td>
            <td v-bind="tdcon('asset_type')">
              <span class="txtov" :title="item['assets']">{{
                $t(item["asset_type"])
              }}</span>
            </td>
            <td v-bind="tdcon('assets')">
              <span class="txtov" :title="item['assets']">{{
                $t(item["assets"])
              }}</span>
            </td>
            <td v-bind="tdcon('licensors')" :title="item['licensors']">
               <span style="white-space:normal;" ><template v-if="item['licensors']">{{ item["licensors"] }}</template><template v-else>{{ $t("licensors") }} {{ $dft.capHead( $t("missing"))}} </template> </span>
            </td>
            <td v-bind="tdcon('last_statement')" :title="item['last_statements']" >
                <span style="white-space:normal;">{{ item["last_statements"] }} </span>
            </td>
          </tr>
        </template>
      </NTable>
    </div>
    <DtPageStatusFloat :statusTV="statusTV" />
    <ModalContainer :modalKey="'advancedSearch'" width="small">
      <AdvancedSearch
        :advancedSearchData="advancedSearchData"
        :initSearchFilter="searchFilter"
        @search="onAdvancedSearch"
        @cancelled="onDialogCancelled"
      />
    </ModalContainer>
    <Sidewindow
      :value="licenceDetailsFlag"
      @closed="onCloseLicencesDetails"
    >
        <LicenceSideWindow :licencesDetails="licencesDetails" />
    </Sidewindow>
    <ModalContainer :modalKey="'addLicence'" :width="'small'">
      <NewLicence @cancelled="onDialogCancelled"/>
    </ModalContainer>

    <ModalContainer :modalKey="'createLicenceForm'" :width="'small'">
      
      <CreateLicenceForm @cancelled="onDialogCancelled" @create="onAddLicence"/>
    
    </ModalContainer>
    <ModalContainer :modalKey="'addLicenceTrack'" :width="'medium'">
      
      <AddRelatedTracksModal @cancelled="onDialogCancelled" @create="onAddTrack"/>
    
    </ModalContainer>

    <ModalContainer :modalKey="'batchLicence'" :width="'small'">
      
      <BatchLicence   
        @cancelled="onDialogCancelled"
      />
    
    </ModalContainer>

    <ModalContainer :modalKey="'licenceLineExport'" :width="'small'">
      
      <ExportLicenceLine   
        @cancelled="onDialogCancelled"
      />
    
    </ModalContainer>

    <ModalContainer :modalKey="'licenceExport'" :width="'small'">
      
      <ExportLicenceModal   
        @cancelled="onDialogCancelled"
      />
    
    </ModalContainer>

    <ModalContainer :modalKey="'licenceBatchReminder'" :width="'small'">
      
      <LicenceBatchReminder   
        @cancelled="onDialogCancelled"
      />
    
    </ModalContainer>

    <!-- <ModalContainer
      @cancelled="onCancel"
      :modalKey="'createInvoiceProjects'"
      :width="'400'"
    >
      <CreateInvoiceModal @create="createInvoice" @cancelled="onCancel" />
    </ModalContainer> -->
    

  </div>
</template>

<script>
// import Modal from '../../../../dt-plugins/modal/modal';
import { LicenceStoreNamespace as storeNS } from "../../store";
import * as ActionTypes from "../../store/types";
import { DTIconButton } from "../../../../plugins/button/button";
import NTable from "../../../../plugins/datatable/datatable";

// import InputField from "@plugins/text-field/input-field";

import { ConfirmationService } from "@/dt-plugins/confirmation/confirmation.service";
import { createNTableConfig } from '../../../../plugins/datatable';

import { createTableHeader } from "../../../../plugins/datatable";
import ModalContainer from "@dtplugins/modal/modal-container";

import { createModalMixin ,closeModalRoute, openModalRoute2  } from "../../../../dt-plugins/modal/modal.mixin";
import { createLDTHost } from "@/dt-plugins/sidewindow/LDTHost.mixin";
 import { defaultConfig } from "@/dt-plugins/sidewindow/config.model";



import Sidewindow from "@/dt-plugins/sidewindow/sidewindow";

import {
  createTV,
  tv,
} from "../../../../models/text-value.model";

import {
  mapGetterObject,
  mapActionObject,
} from "../../../../store/global";
import { licenceAccountsGetters } from '../../store/accounts/getters';
import { licenceAccountsActions } from '../../store/accounts/actions';
import { getlicenceDetailsSelectable, licencesListLDTRoutes } from '../../router/routes';
import {
  onDetailsRowClicked,
  childOfOrEqualDetails,
  handleFromRoute,
} from "../../../../utility/route";


import { createFetchListMixin } from '../../../../dt-plugins/advanced-search/fetch-list.mixin';

import{ range, flatten } from 'ramda';





import { sendMail } from '../../../../utility';
import { licenceService } from '../../services/licence.service';
import AdvancedSearch from './advanced-search'
import { licenceListAdvancedSearchConfig } from './advanced-search.vue';
import { createAdvancedSearchHost } from "../../../../dt-plugins/advanced-search/advance-search.mixin";
import { licenceGetters } from '../../store/licence/getters';
import { licenceActions } from '../../store/licence/actions';
import NewLicence from './add-licence-modal';
import CreateLicenceForm from './create-licence-form';
import LicenceSideWindow from './licence-sidewindow.vue';
import AddRelatedTracksModal from "./add-tracks-modal";
import BatchLicence from './batch-licence-modal.vue';
import ExportLicenceLine from './export-licence-line-modal.vue';
import FileDownload from "js-file-download";
import LicenceBatchReminder from './licence-reminder-modal.vue'
import CreateInvoiceModal from './create-invoice-modal.vue';
import DTCheckbox from "../../../../plugins/checkbox/checkbox";
import DtPageStatusFloat from "@dtplugins/dtpage-status/dtpage-status-float";
import ExportLicenceModal from "./export-licence-modal.vue";
import DtStatus from "@dtplugins/dt-status-dropdown/dt-status";

const LDTConfig = {
  entityName: "licence",
  ldtRoutes: licencesListLDTRoutes,
  detailsSelectableFunction: getlicenceDetailsSelectable,
  primaryKey: "licence_id",
  storeNs: storeNS,
  SELECT_ACTION: ActionTypes.LicenceDetails.FETCH.SINGLE,
  SELECT_AUTO_ACTION: ActionTypes.LicenceDetails.FETCH.SINGLE,
};

export default {
  components: {
    NTable,
  
    // InputField,
    DTIconButton,
    ModalContainer,
    CreateLicenceForm,
    LicenceSideWindow,
    BatchLicence,
    Sidewindow ,
    AdvancedSearch,
    NewLicence,
    ExportLicenceLine,
    LicenceBatchReminder,
    CreateInvoiceModal,
    AddRelatedTracksModal,
    DTCheckbox,
    DtPageStatusFloat,
    ExportLicenceModal,
    DtStatus
  },
  mounted: function () {
    

  },
  data: function () {
    return {
     selectedClickedLicence:null,
     
      defaultConfig: defaultConfig,
      searchType: "none", // release__standard_search, release__weekly_search, release__monthly_search
      dropdownItems: [
        // { title: 'Artist' },
        // { title: 'User' },
        { title: "Export Licence Lines" },
        { title: "Export" },
        // { title: "Batch Licence Reminder" },
      
      ],
    };
  },
   mixins: [
    
    createModalMixin("addLicence"),
    createModalMixin("createLicenceForm"),
    createModalMixin("batchLicence"),
    createModalMixin("licenceLineExport"),
    createModalMixin("addLicenceTrack"),
    createModalMixin("licenceBatchReminder"),
    createModalMixin("createInvoiceProjects"),
    createModalMixin("licenceExport"),
    createLDTHost(LDTConfig),
    
    createFetchListMixin (ActionTypes.LicencesList.FETCH.ALL,100),
  
    createAdvancedSearchHost( licenceListAdvancedSearchConfig ),
    createModalMixin("advancedSearch"),
    // createAdvancedSearchHost(releaseListAdvancedSearchConfig, {
    //   onBeforeAdvancedSearchFetch:
    //     "onBeforeAdvancedSearchFetch",
    // }),
    
  ],
  watch: {
    $route: {
      immediate: true,
      handler: function (to, from) {},
    },
  },
  computed: {
    ...mapGetterObject(storeNS ,licenceGetters),
    filter: function () {
      return {
        ...this.metaFilter,
        basicFilter: this.basicFilter,
        searchFilter: this.searchFilter,
      };
    },

  
    licenceDetailsFlag: function () {
      return childOfOrEqualDetails(licencesListLDTRoutes, this.$route);
    },    
    
    statusTV: function () {
      return (
        this.licencesList?.licence_statuses?.map((e) => {
          return {
            text: e["label_status_name"],
            value: e["label_status_colour"]? e["label_status_colour"]: "000000",
            id: e["label_status_id"],
          };
        }) || []
      );
    },


    // licenceStatusesTV:function(params) {
    //   return createTV(this.licenceAccountsList?.licence_statuses,"licence_status_text","licence_status_id");
    // },


    tableConfig: function () {
      return createNTableConfig({
        rowHeight:  "auto",
        fullHeight: true,
        headerHeight: 40
      });
    },
    list: function() {
     return this.licencesList?.licences||[];
      
    },

    headers: function () {
      return [
       createTableHeader("licence", {  }),
       createTableHeader("account", { text:`${this.$t('account')}/${this.$t('territory')}`  }),
       createTableHeader("active",{ta:"center" ,mw:50}),
       createTableHeader("period",{ta:"center",mw:100 }),
       createTableHeader("asset_type",{ta:"center",mw:100}),
       createTableHeader("assets"),
       createTableHeader("licensors", { }),
       createTableHeader("last_statement", { }),
      ];
    },
    advancedSearchData : function(){
      

      // const maxYear = new Date(this.advancedSearchResponse?.dates.max_date).getFullYear();
      // const minYear=new Date(this.advancedSearchResponse?.dates.min_date).getFullYear();
      // console.log("maxYear,minYear",maxYear,minYear)
      // const hArray = flatten(range(+minYear, +maxYear+1).map(e => {
      //   return [`${e} H1`,`${e} H2`];
      // }));

      return {
        licenceAccountStatusTV:createTV(this.advancedSearchResponse?.licence_account_statuses,"label_status_name","label_status_id")||[],
        licenceTypesTV:createTV(this.advancedSearchResponse?.licence_statuses,"label_status_name","label_status_id"),
        royaltyAccountTV:createTV(this.advancedSearchResponse?.royalty_accounts,"royalty_account_name","royalty_account_id"),
        territoryTV:createTV(this.advancedSearchResponse?.territories,"territory_name","territory_id"),
        //lastStmtTV: createTV(hArray),
      };
    }

  },
  methods: { 
     ...mapActionObject(storeNS, licenceActions),
    fetchAdvancedSearchData :async function(){
      const advancedSearchData = await licenceService.licenceAdvancedSearchModalData();
      console.log("advancedSearchData",advancedSearchData)
      this.advancedSearchResponse = advancedSearchData.data;
      this[ActionTypes.LicencesList.SET.ALL](this.advancedSearchResponse);
    },
    defaultBasicFilter() {       //<-- Needed for BasicSearch. Provide the basic Filter Object. Supports String/Boolean/Number
      return {
        searchString: undefined,
        active: undefined,
      
      };
    },
    onCheckBoxClicked: function (event) {
      this.basicFilter.active = event.target.checked?1:undefined;
      //this.searchType = "none";
      this.resetSearchFilter();
      this.fetchListReset();
    },
    onAddLicenceClicked:function(){
      this.$router.push({
        ...this.$route,
        query: {
          modal: "add_licence",
        },
      });
    },

    addLicenceAccount:function(payload){
      this[ActionTypes.LicenceAccountsList.INSERT.SINGLE](payload);
      this.onCancel();
    },



    selectedRow: function (item) {
      return (
        this.selectedClickedLicence &&
        this.selectedClickedLicence["licence_id"] == item["licence_id"]
      );
    },

    onLicenceClicked: function (item) {
      if (this.loadingFlag) {
        return;
      }
      this.selectedClickedLicence = item;
      this.$router.push({
        name: licencesListLDTRoutes.names.tab,
        params: {
          licence_id: item.licence_id,
          tab: "overview",
        },
      });
    },
    onCloseLicenceAccountsDetails:function(){
      this.selectedClickedLicence = null;
      this.fetchListReset();
      handleFromRoute(this, () => {
        this.$router.push({
          name: licencesListLDTRoutes.names.list,
        });
      });
    },
    onAdvancedSearchClick: function () {
      this.$router.push({
        ...this.$route,
        query: {
          modal: "advanced_search",
        },
      });
    },
    onDialogCancelled: function () {
      this.$router.push({
        ...this.$route,
        query: {
          modal: undefined,
        },
      });
    },

    onCloseLicencesDetails:function(){
      this.selectedClickedLicence= null;
      this.fetchListReset();
      handleFromRoute(this, () => {
        this.$router.push({
          name: licencesListLDTRoutes.names.list,
        });
      });
    },
  
     
 
   
    
    onAccountsNext:function(value){
        this.scrollSubject.next(value);
    },
    closeModal:function(){
      // closeModalRoute(this);
    },
 
    onCancel: function () {
     closeModalRoute(this);
    },

    onAddLicence:async function(payload){
     // this[ActionTypes.LicencesList.INSERT.SINGLE](payload);
      const newLicence = await licenceService.addLicence({ ...payload });
      console.log(newLicence,"newLicence")
      this.fetchListReset();
      this.onLicenceClicked({ licence_id:newLicence.data.licence_id});

    },

    onAddTrack:function(payload){
        this[ActionTypes.LicenceRelatedTracks.INSERT.SINGLE](payload);
        this.onCancel();
    },
    onMenuItemClicked: function (item) {
      switch (item.title) {
        case "Export Licence Lines": {
          this.onLicenceLineClick();
          break;
        }
        case "Export": {
          this.onExportClick();
          break;
        }
        case "Batch Licence Reminder": {
          this.onBatchClick();
          break;
        }
  
      }
    },

    onBatchClick:function(){
        this.$router.push({
          ...this.$route,
          query: {
            modal: "batch_licence"
          }
      });
    },
    onLicenceLineClick:function(){
      this.$router.push({
          ...this.$route,
          query: {
            modal: "licence_line_export"
          }
      });
    },

    onExportClick:function(){

      this.$router.push({
          ...this.$route,
          query: {
            modal: "licence_export"
          }
      });
      // const listIds=this.list.map(e=>{
      //   return `${e.licence_id}`
      // })
      // const fileBlob =licenceService.exportLicences(listIds).then(res=>{
      //   FileDownload(res.data,'licence.xlsx');
      // });

      

      // console.log("fileBlob",fileBlob);

    },
    onStatusChange: function (payload) {
      //const item = this.selectedReleaseDetails;
      console.log({...payload},"STATUS")

      const statusPayload= {
        kVal: payload.itemID,
        name: 'status',
        value: payload
      };
      
      this[ActionTypes.LicencesList.UPDATE.SINGLE](statusPayload);
      
      //this[ActionTypes.ReleaseList.UPDATE.SINGLE](payload);
      //console.log(payload,payload)
    },

    createInvoice:function(){
      
    }








  },
};
</script>

<style lang="scss">
.cmp-licences-licences-licence_list {
  .dt-page--top-bar {
    .search {
      .dt-checkbox-control {
        .dt-checkbox-label {
          color: var(--text-accent);
          font-weight: 500;
        }
      }
    }
  }
}

.status {
  flex: 1;
  display: flex;
  align-items: center;
  max-width: 150px;
  .square {
    width: 15px;
    height: 15px;
    margin-right: 10px;
    border: 1px solid;
  }
}
</style>